export const community = {
  popularObjects: 'Ítems Populares',
  loadMore: 'Cargar más',
}



// WEBPACK FOOTER //
// ./src/sections/community/text.js